"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FONT_WEIGHTS = exports.FALLBACK_FONT = void 0;
var FALLBACK_FONT = exports.FALLBACK_FONT = 'sans-serif';
var FONT_WEIGHTS = exports.FONT_WEIGHTS = Object.freeze({
  normal: 400
});